import { MdTraffic } from "react-icons/md";
import { FaBusAlt } from "react-icons/fa";
import { IoStorefront } from "react-icons/io5";
import { HiNewspaper } from "react-icons/hi2";

export const services = [
  {
    title: "Ordinance Violation System",
    description:
      "The LGU-Talibon platform enables citizens to settle traffic and ordinance violations online through a quick, contactless, and cashless process, ensuring efficient resolution without the need for physical visits.",
    icon: MdTraffic
  },
  {
    title: "Miscellaneous Fees",
    description:
      "LGU-Talibon provides a convenient solution for paying college-related fees, such as administrative and processing charges, through its digital platform.",
    icon: HiNewspaper
  },
  {
    title: "Transport Franchise",
    description:
      "Through LGU-Talibon's e-services, transport operators can easily apply for franchises to operate public or private vehicles, ensuring compliance with local regulations.",
    icon: FaBusAlt
  },
  {
    title: "Public Market Stall",
    description:
      "LGU-Talibon supports local entrepreneurs by offering a digital system to lease public market stalls, promoting small businesses and local economic growth.",
    icon: IoStorefront
  }
];

export const initialContactUsForm = {
  first_name: "",
  last_name: "",
  email_address: "",
  mobile_number: "",
  subject: "",
  message: ""
};

export const HOTLINE = [
  {
    office: "MDRRM OFFICE",
    hotline: "Hotline 038-508-1081",
    mobile: "Mobile 0910 503 5390"
  },
  {
    office: "GMPH",
    hotline: "Hotline 038-412-3255",
    mobile: "Mobile 0928 269 3241 / 0956 509 2241"
  },
  {
    office: "Coast Guard Talibon",
    hotline: "Hotline -",
    mobile: "Mobile 0909 693 8871"
  },
  {
    office: "BFP TALIBON",
    hotline: "Hotline -",
    mobile: "Mobile 0950 632 9025"
  },
  {
    office: "TARSIER TALIBON",
    hotline: "Hotline -",
    mobile: "Mobile 0919 066 0667"
  },
  {
    office: "PNP TALIBON",
    hotline: "Hotline -",
    mobile: "Mobile 0998 598 6442"
  },
  {
    office: "BOHECO 2 Talibon",
    hotline: "Hotline -",
    mobile: "Mobile 0917 311 1782 / 0917 148 6790"
  },
  {
    office: "MTO TALIBON",
    hotline: "Email mtotalibonbohol@gmail.com",
    mobile: "Mobile 0918 569 9383"
  },
  {
    office: "MASSO TALIBON",
    hotline: "Email masso.talibon@gmail.com",
    mobile: "Mobile 0919 066 0667"
  },
  {
    office: "MAYOR’S OFFICE",
    hotline: "Hotline 422-2895",
    mobile: "Mobile motalibon@gmail.com"
  }
];

export const socialIcons = [
  "facebook.svg",
  "instagram.svg",
  "tiktok.svg",
  "twitter.svg",
  "youtube.svg"
];
